// Keep in sync with lambdas/common/backend/enums/placement-task.ts
export enum PlacementTask {
    ObtainIncumbentRenewalPolicy = 'ObtainIncumbentRenewalPolicy',
    ObtainExpiringPolicy = 'ObtainExpiringPolicy',
    EvaluateRemarketingNeed = 'EvaluateRemarketingNeed',
    Remarketing = 'Remarketing',
    SendProposal = 'SendProposal',
    SendSolicitation = 'SendSolicitation',
    SendCancellationRequest = 'SendCancellationRequest',
    FollowupEmail = 'FollowupEmail',
}
